import Theatre from './../pages/theatre'
import Staff from './../pages/staff'
import Bios from './../pages/bios'
import Shows from './../pages/shows'
//import Tickets from './../pages/tickets'
import Sponsors from './../pages/sponsors'

import Support from './../pages/support'
import Ads from './../pages/ads'
import ITS from './../pages/its'

const Routes = {
	Header: [{
		path: '/theatre',
		label: 'Theatre',
		component: Theatre
	}, {
		path: '/staff',
		label: 'Staff',
		component: Staff
	}, {
		path: '/bios',
		label: 'Bios',
		component: Bios
	}, {
		path: '/shows',
		label: 'Shows',
		component: Shows
	}, {
		path: '/support',
		label: 'Support',
		component: Support
	}, {
		path: '/ads',
		label: 'Ads',
		component: Ads
	}, {
		path: '/its',
		label: 'ITS',
		component: ITS
	// }, {
	// 	path: '/tickets',
	// 	label: 'Tickets',
	// 	component: Tickets
	}, {
		path: '/sponsors',
		label: 'Sponsors',
		component: Sponsors
	}]
}

export default Routes


// WEBPACK FOOTER //
// ./src/pages/_routes.js